import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'dateTimezone',
  standalone: true,
})
export class DateTimezonePipe implements PipeTransform {
  public transform(date?: Date | null, format = 'M/d/yy h:mm a ZZZZ'): string {
    if (!date) {
      return '(Not set)';
    }
    return DateTime.fromJSDate(new Date(date), { zone: 'utc' }).setZone('America/Anchorage').toFormat(format);
  }
}
